import {NgModule} from '@angular/core';
import {IonicPageModule} from 'ionic-angular';
import {WebCamModule} from 'ack-angular-webcam';

import {IdentificationCheckOnWebPage} from './identification-check-on-web';

@NgModule({
  declarations: [
    IdentificationCheckOnWebPage,
  ],
  imports: [
    IonicPageModule.forChild(IdentificationCheckOnWebPage),
    WebCamModule,
  ],
  exports: [
    IdentificationCheckOnWebPage
  ]
})
export class IdentificationCheckOnWebPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/identification-check-on-web/identification-check-on-web.module.ts